import { styled } from '@mui/material'
import { TrendColorizerText } from 'components/TrendColorizer'
import { PRIMARY_CURRENCY } from 'constants/currencies'
import { COMPRESSED_VALUE_SCALE } from 'constants/trade'
import dayjs from 'dayjs'
import numbro from 'numbro'
import { memo } from 'react'
import { Tick } from 'store/orderbook/types'
import { OrderDirection } from 'store/spot/types'
import { toFixed } from 'utils/number'
import { SectionWrap } from '../../styles'
import Decimal from 'decimal.js'
import { RecentTradesTabs } from './Tabs'

const RecentTradesWrap = styled(SectionWrap)`
  height: 315px;
  /* max-height: 350px; */
  padding: 0 16px;
  /* overflow: hidden; */
  border-top: 1px solid rgba(46, 54, 59, 1);
`
const ListWrap = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  margin: 0 -16px;
  overflow-y: auto;
  height: 100%;
  ${(props) => props.theme.breakpoints.down('md')} {
    flex-direction: row;
    height: 300px;
    flex: unset;
    position: relative;
  }
`
const PriceHolder = styled('div')`
  flex: 1;
  display: flex;
  flex-flow: column;
  > :not(:last-of-type) {
    margin-bottom: 2px;
  }
`
// TODO: using grid to refactor this component
export const TokenSymbol = styled('div')`
  height: 24px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color.text50};
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  .price {
    width: 70px;
    text-align: left;
  }
  .amount {
    width: 86px;
  }
  .total {
    flex: 1;
    ${(props) => props.theme.breakpoints.down('md')} {
      display: none;
    }
  }
  .size {
    width: 70px;
  }
  .time {
    flex: 1;
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
const TradeItemWrap = styled('div')`
  display: flex;
  align-items: center;
  padding: 0;
  color: ${(props) => props.theme.color.text70};
  height: 20px;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  .size {
    width: 70px;
  }
  .time {
    flex: 1;
    // margin-right: -4px;
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    justify-content: space-between;
    .time,
    .size,
    .price {
      width: unset;
      flex: unset;
    }
  }
`
const TradeTokenSymbol = styled(TokenSymbol)`
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
    justify-content: space-between;
    .time,
    .size,
    .price {
      width: unset;
      flex: unset;
    }
  }
`
const PriceColumn = styled(TrendColorizerText)`
  width: 70px;
  font-weight: 600;
  text-align: left;
`

export const RecentTrades = memo<{
  list?: Tick[]
  baseScale: number
  quoteScale: number
  multiplier?: number
}>(({ list, baseScale, quoteScale, multiplier }) => {
  const average = quoteScale >= COMPRESSED_VALUE_SCALE

  return (
    <RecentTradesWrap>
      <RecentTradesTabs />
      <TradeTokenSymbol>
        <span className="price">Price({PRIMARY_CURRENCY})</span>
        <span className="size">Size({PRIMARY_CURRENCY})</span>
        <span className="time">Time</span>
      </TradeTokenSymbol>
      <ListWrap>
        <PriceHolder>
          {list?.map((tickItem, index) => {
            const {
              key = '',
              timestamp = 0,
              direction = 0,
              price = 0,
              quantity = 0,
            } = tickItem
            const size = multiplier
              ? Decimal.mul(quantity, multiplier).toFixed()
              : quantity
            return (
              <TradeItemWrap key={key}>
                <PriceColumn $trend={direction === OrderDirection.LONG}>
                  {toFixed(price, quoteScale, {
                    fixed: true,
                  })}
                </PriceColumn>
                <span className="size">
                  {numbro(size).format({
                    average,
                    thousandSeparated: true,
                    mantissa: average ? 2 : baseScale,
                    optionalMantissa: true,
                  })}
                </span>
                <span className="time">
                  {dayjs(timestamp).format('HH:mm:ss')}
                </span>
              </TradeItemWrap>
            )
          })}
        </PriceHolder>
      </ListWrap>
    </RecentTradesWrap>
  )
})
